/** Editorial light — photography-first, calm Hegre-adjacent mood. */
export const lightColors = {
    primary: '#4A148C',
    secondary: '#FF4081',
    accent: '#00E5FF',
    link: '#00727C',
    background: '#F5F5F5',
    surface: '#FFFFFF',
    surfaceElevated: '#FAFAFA',
    text: '#0D0D0D',
    textMuted: '#6B6178',
    border: '#E4DDE8',
    error: '#C62828',
    onPrimary: '#F5F5F5',
};
/** Night editorial twin — FetMode dark, not neon cam-site. */
export const darkColors = {
    primary: '#4A148C',
    secondary: '#FF4081',
    accent: '#00E5FF',
    link: '#00E5FF',
    background: '#0D0D0D',
    surface: '#141019',
    surfaceElevated: '#1B1524',
    text: '#F5F5F5',
    textMuted: '#A99CB6',
    border: '#241C30',
    error: '#FF5252',
    onPrimary: '#F5F5F5',
};
export const defaultTheme = {
    id: 'fetmode-default',
    displayName: 'FetMode',
    colors: lightColors,
    colorModes: {
        light: lightColors,
        dark: darkColors,
    },
    fonts: {
        heading: "'Fraunces', Georgia, 'Times New Roman', serif",
        body: "'Hanken Grotesk', system-ui, -apple-system, sans-serif",
    },
    branding: {
        logoUrl: '/brand/logo.png',
        faviconUrl: '/brand/logo.png',
        showPoweredBy: false,
    },
};
//# sourceMappingURL=defaultTheme.js.map